<template>
    <div component="ClientHeader">
        <div class="select cell">
            <client-select />
        </div>
        <div class="name cell" v-if="getClient">
            <h3>Project list</h3>
            <h2>{{ getClient.obchodne_meno }}</h2>
        </div>
        <div class="action cell" v-if="getClient">
            <btn :text="'Create new project'" :icon="'add_circle'" @click="setIsNewProjectPopup(true)"></btn>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ClientSelect from '@/components/Client/ClientSelect';

export default {
    name: 'ClientHeader',

    components: { ClientSelect },

    methods: {
        ...mapMutations(['setIsNewProjectPopup']),
    },

    computed: {
        ...mapGetters(['getClient']),
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ClientHeader'] {
    display: flex;
    align-items: flex-start;
    flex: 0 !important;

    .select {
        flex: 0.4;
        max-width: 500px;
    }

    .name {
        flex: 0.5;
        padding: 0 20px;

        h3 {
            margin-top: 0;
        }
    }

    .action {
        flex: 0.1;
    }
}
</style>
